import type { UseArticlePageHeadResult } from '@/domains/articles/types/ArticlePage.types'
import type { HeadLink, HeadMeta, I18nParams } from '@/types/shared-types'

export default function useArticlePageHead(article: Record<string, any> | null | undefined): UseArticlePageHeadResult {

  const { t } = useI18n()
  const baseUrl = 'https://www.benefitsystems.pl'

  const getPageTitle = () => {
    return article?.title || t('pageTitles.articles.title') || ''
  }

  const getPageLink = () => {
    const link: HeadLink[] = []

    link.push({
      hid: 'favicon',
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico',
    })

    link.push({
      rel: 'canonical',
      href: `${baseUrl}${article?.url}`,
    })

    Object.entries(article?.urlsByIsoCode).forEach(([key, value]) => {
      const langKey = key === 'pl-PL' ? 'pl' : 'en'
      link.push({
        rel: 'alternate',
        hreflang: langKey,
        href: `${baseUrl}${article?.urlsByIsoCode[key]}`,
      })
    })

    link.push({
      rel: 'alternate',
      hreflang: 'x-default',
      href: `${baseUrl}${article?.url}`,
    })

    return link
  }

  const getPageMeta = () => {
    const meta: HeadMeta[] = []

    meta.push({
      name: 'description',
      content: article?.description || '',
    })

    return meta
  }

  const get18nParams = () => {
    const I18nParams: I18nParams = {}

    Object.entries(article?.urlsByIsoCode).forEach(([key, value]) => {
      const langKey = key === 'pl-PL' ? 'pl' : 'en'
      const urlSegment = value.split('/').filter(Boolean).pop()
      I18nParams[langKey] = { url: urlSegment }
    })

    return I18nParams
  }

  return {
    title: getPageTitle(),
    link: getPageLink(),
    meta: getPageMeta(),
    I18nParams: get18nParams(),
  }
}
